import {Injectable} from '@angular/core'
import {BehaviorSubject} from 'rxjs/BehaviorSubject'
import {StorageService} from 'app/core/upload/upload.service'

@Injectable()
export class ProjectService {
  public creatives: any[] = []
  public focused: string[] = []
  public metaKey: boolean = false
  currentCreative$ = new BehaviorSubject<number>(-1)

  constructor(private storage: StorageService) {}

  get currentCreative() {
    return this.currentCreative$.value
  }

  prev() {
    return this.creatives[
      (this.currentCreative$.value + this.creatives.length - 1) %
        this.creatives.length
    ]
  }

  next() {
    return this.creatives[
      (this.currentCreative$.value + 1) % this.creatives.length
    ]
  }

  download(archiveName) {
    let files = this.creatives
    if (this.focused.length > 0)
      files = files.filter(c => this.focused.includes(c.id))
    files = [].concat.apply([], files)
    this.storage.downloadFiles(files, archiveName)
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/project.service.ts